import { render, staticRenderFns } from "./statusList.vue?vue&type=template&id=7723485d&scoped=true&"
import script from "./statusList.vue?vue&type=script&lang=js&"
export * from "./statusList.vue?vue&type=script&lang=js&"
import style0 from "./statusList.vue?vue&type=style&index=0&id=7723485d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7723485d",
  null
  
)

export default component.exports